import React, { useState, useEffect, useContext } from 'react';
import {
    Grid,
    Typography,
    Box,
    Snackbar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import CateringEventResults from './CateringEventResults';
import CateringDashboardContext from '../CateringDashboardContext';
import CateringContext from '../../../CateringContext';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
import { useStyles } from '../../../../home/useStyles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment-timezone';
// import moment from 'moment';

const CateringDashboardSub = (props) => {
    const { restauHook } = useContext(RestauInfoContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
        noSsr: true,
    });
    useEffect(() => {}, [restauHook.restauId]);

    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(true);
    const [results, setResults] = useState([]);
    const {
        prioritySubmission,
        priorityFollowup,
        priorityConfirmed,
        priorityRecent,
        refreshToggle,
    } = useContext(CateringDashboardContext);
    const {
        retrieveFilteredEvents,
        snackbarOpen,
        setSnackbarOpen,
        snackbarMessage,
        snackbarAction,
    } = useContext(CateringContext);
    const classes = useStyles();

    useEffect(() => {
        const updateDashboardSub = async (filters, sort, title) => {
            setLoading(true);
            try {
                const response = await retrieveFilteredEvents(filters);
                const sortedResults = sort(response.data.filteredEvents);
                setResults(sortedResults);
                setTitle(`${title} (${sortedResults.length})`);
            } catch (error) {
                console.log('Error fetching events: ', error);
            } finally {
                setLoading(false);
            }
        };

        let todayStart = moment
            .tz('America/Los_Angeles')
            .startOf('day')
            .add(1, 'second');

        let todayEnd = moment
            .tz('America/Los_Angeles')
            .endOf('day')
            .subtract(1, 'second');

        let tomorrowStart = moment
            .tz('America/Los_Angeles')
            .add(1, 'days')
            .startOf('day')
            .add(1, 'second');

        let tomorrowEnd = moment
            .tz('America/Los_Angeles')
            .add(1, 'days')
            .endOf('day')
            .subtract(1, 'second');

        switch (props.value) {
            case 'inquiryToReachOut':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['New Event'],
                            type: 'dropdown',
                        },
                    ],
                    prioritySubmission,
                    props.title
                );
                break;
            case 'inquiryToFollowUp':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['FollowUp'],
                            type: 'dropdown',
                        },
                    ],
                    priorityFollowup,
                    props.title
                );
                break;
            case 'confirmedUpcoming':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'confirmedUpcomingToday':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                        {
                            field: 'eventDate',
                            operator: '<=',
                            value: todayEnd.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'confirmedUpcomingTomorrow':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: tomorrowStart.toISOString(),
                            type: 'date',
                        },
                        {
                            field: 'eventDate',
                            operator: '<=',
                            value: tomorrowEnd.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'confirmedUpcomingInvoicePaid':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'paymentStatus',
                            operator: 'in',
                            value: ['Invoice_Paid'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'confirmedUpcomingInvoicePending':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'paymentStatus',
                            operator: 'in',
                            value: ['Invoice_Pending'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'confirmedUpcomingDepositPaid':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'paymentStatus',
                            operator: 'in',
                            value: ['Deposit_Paid'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'confirmedUpcomingDepositPending':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'paymentStatus',
                            operator: 'in',
                            value: ['Deposit_Pending'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '>=',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            case 'recentPast':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '<',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityRecent,
                    props.title
                );
                break;
            case 'recentPastInvoicePending':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'paymentStatus',
                            operator: 'in',
                            value: ['Invoice_Pending'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '<',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityRecent,
                    props.title
                );
                break;
            case 'recentPastInvoicePaid':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Confirmed'],
                            type: 'dropdown',
                        },
                        {
                            field: 'paymentStatus',
                            operator: 'in',
                            value: ['Invoice_Paid'],
                            type: 'dropdown',
                        },
                        {
                            field: 'eventDate',
                            operator: '<',
                            value: todayStart.toISOString(),
                            type: 'date',
                        },
                    ],
                    priorityRecent,
                    props.title
                );
                break;
            case 'void':
                updateDashboardSub(
                    [
                        {
                            field: 'eventStatus',
                            operator: 'in',
                            value: ['Void'],
                            type: 'dropdown',
                        },
                    ],
                    priorityConfirmed,
                    props.title
                );
                break;
            default:
                break;
        }
    }, [props.title, restauHook.restauId, refreshToggle]);

    return (
        <div>
            {loading ? (
                <img
                    className={classes.loadingImage}
                    src="/img/spinner.gif"
                    alt="loading"
                />
            ) : (
                <Accordion defaultExpanded={!isMobile}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography color="primary" variant="h6">
                            {title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {results.length === 0 ? (
                            <Typography variant="body2">
                                No results available
                            </Typography>
                        ) : (
                            <Box
                                style={{
                                    overflowY: 'auto',
                                    width: '100%',
                                    maxHeight: '45vh',
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={12}>
                                        {results.map((result, i) => (
                                            <CateringEventResults
                                                key={result.inquiryId}
                                                color={
                                                    i % 2
                                                        ? '#EAE9F8'
                                                        : '#ddf1e9'
                                                }
                                                style={{
                                                    height: '20vh',
                                                    overflow: 'auto',
                                                }}
                                                data={result}
                                                field={props.field}
                                                fieldName={props.fieldName}
                                            />
                                        ))}
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </AccordionDetails>
                </Accordion>
            )}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                message={snackbarMessage}
                onClose={(event, reason) => {
                    if (reason === 'clickaway') return;
                    setSnackbarOpen(false);
                }}
                action={snackbarAction}
            />
        </div>
    );
};

export default CateringDashboardSub;
